export const incomeList = [
    {
        description: 'incomeList.level1',
        label: 'incomeList.level1',
        type: 'incomeList',
        value: '1'
    },
    {
        description: 'incomeList.level2',
        label: 'incomeList.level2',
        type: 'incomeList',
        value: '2'
    },
    {
        description: 'incomeList.level3',
        label: 'incomeList.level3',
        type: 'incomeList',
        value: '3'
    },
    {
        description: 'incomeList.level4',
        label: 'incomeList.level4',
        type: 'incomeList',
        value: '4'
    },
    {
        description: 'incomeList.level5',
        label: 'incomeList.level5',
        type: 'incomeList',
        value: '5'
    },
    {
        description: 'incomeList.level6',
        label: 'incomeList.level6',
        type: 'incomeList',
        value: '6'
    }
];

export default incomeList;